export default __webpack_public_path__ + "static/media/impact-effort-analysis-template.fd68442f.pdf";